import { render, staticRenderFns } from "./SRIOItem.vue?vue&type=template&id=68b7e3b8"
import script from "./SRIOItem.vue?vue&type=script&lang=js"
export * from "./SRIOItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68b7e3b8')) {
      api.createRecord('68b7e3b8', component.options)
    } else {
      api.reload('68b7e3b8', component.options)
    }
    module.hot.accept("./SRIOItem.vue?vue&type=template&id=68b7e3b8", function () {
      api.rerender('68b7e3b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Study/SRIOItem.vue"
export default component.exports